<template>
    <v-dialog v-model="internalDialog" persistent no-click-animation max-width="360" content-class="confirm-dialog">
      <v-card>
        <v-card-title class="text-h5">
          {{ title }}
        </v-card-title>
        <v-card-text>
            <div v-html="content"></div>
        </v-card-text>
        <v-card-actions class="justify-center">
            <v-btn color="green darken-1" text @click="confirm" :large="$vuetify.breakpoint.mdAndUp" outlined>
            はい
            </v-btn>
            <v-btn color="red darken-1" text @click="cancel" :large="$vuetify.breakpoint.mdAndUp" outlined>
            いいえ
            </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </template>
  
  <script>
  export default {
    props: {
      title: {
        type: String,
        required: true
      },
      content: {
        type: String,
        required: true
      },
      dialog: {
        type: Boolean,
        required: true
      }
    },
    data() {
      return {
        internalDialog: this.dialog
      };
    },
    watch: {
      dialog(val) {
        this.internalDialog = val;
      },
      internalDialog(val) {
        this.$emit('dialog-changed', val);
      }
    },
    methods: {
      confirm() {
        this.$emit('confirm');
        this.internalDialog = false;
      },
      cancel() {
        this.$emit('cancel');
        this.internalDialog = false;
      }
    }
  };
  </script>
  
  <style>
  @media only screen and (min-width: 960px) {
    .confirm-dialog .v-card__text {
      font-size: 18px !important;
      text-align: center;
    }
  }
  </style>